"use client";
import React from "react";
import { FileQuestion, FileText } from "lucide-react";
import { Action, StatusFile, TypeFile, TypeLayout } from "@/app/constants/enums";
import { iProProjectMain } from "@/app/models/interfaceProject";
import InputChat from "../../Elements/Core/InputChat";
import Tooltip from "../../Elements/Tooltip";
import Loading from "../../Elements/Loading";

interface SourcesListProps {
  userLoading: boolean;
  userProject: iProProjectMain;
  typeLayout: TypeLayout;
}

const SourcesList: React.FC<SourcesListProps> = ({
  userLoading,
  userProject,
  typeLayout
}) => {
  return (
    <div>
       

      {userLoading ? (
        "loading..."
      ) : (
        <>
          {userProject.qa.length > 0 && (
            <label
              key="qa"
              className="flex justify-between items-center w-full cursor-pointer py-2"
            >
              <div className="flex items-center space-x-2 max-w-[85%]">
                <FileQuestion
                  strokeWidth={1}
                  className="text-blue-500 w-6 h-6 flex-shrink-0"
                />
                <span className="truncate hover:text-blue-700">
                  <Tooltip
                    text={`${userProject.qa.length} Preguntas y Respuestas`}
                  >
                    {userProject.qa.length} Pregunta(s) y Respuesta(s)
                  </Tooltip>
                </span>
              </div>
            </label>
          )}

          {userProject?.docs?.map((doc) => (
            <label
              key={doc.file_id}
              className="flex justify-between items-center w-full cursor-pointer py-2"
            >
              <div className="flex items-center space-x-2 max-w-[85%]">
                <FileText
                  strokeWidth={1}
                  className={`${
                    doc?.type === TypeFile.Pdf
                      ? "text-red-500"
                      : "text-green-500"
                  } w-6 h-6 flex-shrink-0`}
                />
                <span className="truncate hover:text-blue-700">
                  <Tooltip
                    text={`${
                      doc.status === StatusFile.Created ? "Procesando " : ""
                    }${doc.name}`}
                  >
                    {doc.name}
                  </Tooltip>
                </span>
              </div>
              {doc.status === StatusFile.Created && (
                <Loading w="w-2" h="h-2" className="" />
              )}
            </label>
          ))}
        </>
      )}
    </div>
  );
};

export default SourcesList;
